<template>
  <div
    id="content-color">
    <v-divider></v-divider>

    <!-- Edit Form -->
    <form
      name="colorContentItemForm"
      class="mt-5"
      v-if="tab === 'edit'"
      @submit.prevent="updateContentItem('textItemUpdate')">
      <v-color-picker
        v-model="contentItem.content"
        :swatches="activeColorsForSwatches"
        show-swatches>
      </v-color-picker>

      <div class="page-buttons d-flex my-5">
        <v-btn
          type="submit"
          color="primary">
          Save
        </v-btn>

        <v-btn
          @click="goToContentList"
          type="button"
          color="primary"
          class="mr-auto order-first"
          outlined>
          Cancel
        </v-btn>
      </div>
    </form>
    <!-- / Edit Form -->

    <!-- Revisions -->
    <Revisions
      v-if="tab === 'revisions'"
    />
    <!-- / Revisions -->
  </div>
</template>

<script>
import ContentItemMixin from '../mixin.content-item';
import Revisions from './Revisions.vue';

export default {
  name: 'ContentText',
  props: ['tab'],
  mixins: [
    ContentItemMixin,
  ],
  components: {
    Revisions,
  },
};
</script>

<style lang="scss">
#content-color {
  form[name="colorContentItemForm"] {
    max-width: 300px;
  }

  form[name="revisionsForm"] {
    max-width: 500px;
  }
}
</style>
